window.BOLD = window.BOLD || {};
BOLD.BMS = BOLD.BMS || {};

BOLD.BMS.QuickCart = (function ($) {
  /**
   * adds an item to the customer's cart using the information in the form.
   *
   * @param {jquery} $form the form jquery object
   */
  /** custom printful TODO --- remove */
  // function addCustomFromForm($form) {
  //   var data = $form.serialize();
  //   var customProductType = $('#custom-product-type').val();
  //   var element = document.querySelector('.product-images-wrap');
  //   var key = '';
  //   if (customProductType === 'saftb') {
  //     if ($('.product-editor-custom-text').length) {
  //       var variantID = $('#productSelect').val();
  //       var productText = $('#custom-text').val().toUpperCase();
  //       var productTitleColor = $('#title-text-color').val();
  //       var productTextColor = $('#custom-text-color').val();
  //       var productFont = $('#custom-text-font').val();

  //       if (productText === 'CUSTOM TEXT') {
  //         $('.custom-product-field-group--custom-text').addClass('error');
  //         $('.custom-product-field-group--custom-text .field-error').text(
  //           'Replace with your custom text.'
  //         );
  //         return;
  //       }
  //       key =
  //         '"' +
  //         variantID +
  //         productTitleColor +
  //         productText +
  //         productTextColor +
  //         productFont +
  //         '"';
  //     } else {
  //       key = '"' + variantID + '"';
  //     }
  //   } else if (customProductType === 'color-tee') {
  //     var variantID = $('#productSelect').val();
  //     var textColor = $('#color-tee-text-color').val();
  //     key = '"' + variantID + textColor + '"';
  //   } else if (customProductType === 'saftb-flag') {
  //     if ($('.product-editor-custom-text').length) {
  //       var variantID = $('#productSelect').val();
  //       var productText = $('#custom-text').val().toUpperCase();
  //       var productPrimaryColor = $('#custom-flag-color-primary').val();
  //       var productSecondaryColor = $('#custom-flag-color-secondary').val();
  //       if (productText === 'CUSTOM TEXT') {
  //         $('.custom-product-field-group--custom-text').addClass('error');
  //         $('.custom-product-field-group--custom-text .field-error').text(
  //           'Replace with your custom text.'
  //         );
  //         return;
  //       }
  //       key =
  //         '"' +
  //         variantID +
  //         productPrimaryColor +
  //         productSecondaryColor +
  //         productText +
  //         '"';
  //     } else {
  //       key = '"' + variantID + '"';
  //     }
  //   } else {
  //     if ($('.product-editor-jersey-name').length) {
  //       var variantID = $('#productSelect').val();
  //       var customName = $('#custom-name').val().toUpperCase();
  //       var customNumber = $('#custom-number').val().toUpperCase();

  //       if (customName === 'YOUR NAME') {
  //         $('.custom-product-field-group--custom-text').addClass('error');
  //         $('.custom-product-field-group--custom-text .field-error').text(
  //           'Replace with a custom name.'
  //         );
  //         return;
  //       }
  //       key = '"' + variantID + customName + customNumber + '"';
  //     } else {
  //       key = '"' + variantID + '"';
  //     }
  //   }

  //   key = key.replace(/\s/g, '');
  //   element.querySelectorAll('svg').forEach(function (item) {
  //     item.setAttribute('width', item.getBoundingClientRect().width);
  //     item.setAttribute('height', item.getBoundingClientRect().height);
  //     item.style.width = null;
  //     item.style.height = null;
  //   });

  //   html2canvas(element, {
  //     useCORS: true,
  //     logging: true,
  //     y: element.offsetTop
  //   })
  //     .then(function (canvas) {
  //       var capturedData = localStorage.getItem('bss-custom-products');
  //       if (capturedData) {
  //         // Cart not empty
  //         capturedData = JSON.parse(capturedData);
  //         capturedData[key] = canvas.toDataURL('image/jpeg', 0.5);
  //         localStorage.setItem(
  //           'bss-custom-products',
  //           JSON.stringify(capturedData)
  //         );
  //       } else {
  //         // Cart empty
  //         var product = {};
  //         product[key] = canvas.toDataURL('image/jpeg', 0.5);
  //         localStorage.setItem('bss-custom-products', JSON.stringify(product));
  //       }
  //       addItemToCart(data);
  //     })
  //     .catch(function (err) {
  //       console.error(err);
  //       addItemToCart(data);
  //     });
  // }

  const spinnerWidget =
    '<i class="cart-loading fa fa-spin fa-lg fa-spinner"></i>';

  const buttonTextResetTime = 3000;

  function openCartDrawer() {
    document.body.classList.add('quick-cart--active');
    addCartDrawerListeners();
    // Rebuy
    if (typeof Rebuy !== 'undefined') {
      Rebuy.init();
    }
  }
  function closeCartDrawer() {
    document.body.classList.remove('quick-cart--active');
  }

  function updateCartItemCounts(count) {
    document.querySelectorAll('.cart-item-count').forEach(el => {
      el.textContent = count;
      if (count > 0) {
        document.querySelector('.cart').classList.add('cart--active');
        document.querySelector('.cart-item-count').classList.remove('hide');
      } else {
        document.querySelector('.cart').classList.remove('cart--active');
        document.querySelector('.cart-item-count').classList.add('hide');
      }
    });
  }

  function updateCtaLoadingState(element) {
    if (!element) return;
    const ctaText = element.innerText;
    element.innerHTML = spinnerWidget;

    setTimeout(() => {
      element.innerText = ctaText;
    }, buttonTextResetTime);
  }

  async function addItemToCart(data, element) {
    updateCtaLoadingState(element);
    const requestData = {
      items: [{ id: data.id, quantity: 1 }]
    };
    // Adding item to the cart and getting the item back
    await fetch('/cart/add.js', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestData)
    });

    // hide the mobile modal
    const productModal = document.getElementById('product-modal');
    if (!productModal) return;
    productModal.setAttribute('active', 'false');

    // get the cart count
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    await updateCartItemCounts(cart.item_count);

    // update cart
    await replaceCartContents();

    // open drawer
    openCartDrawer();
    dataLayer.push({ event: 'quick_add_to_cart' });
  }

  /**
   *
   * @param {integer} scrollPosition
   */
  async function replaceCartContents(scrollPosition) {
    const res = await fetch('/?section_id=quick-cart');
    const text = await res.text();
    const html = document.createElement('div');

    html.innerHTML = text;

    const newBox = html.querySelector('.quick-cart').innerHTML;

    document.querySelector('.quick-cart').innerHTML = newBox;

    const quickCartItems = document.querySelector('.quick-cart__inner');
    // Restore the scroll position
    quickCartItems.scrollTop = scrollPosition;

    // add back the listeners due to Shopify's Section API re-rendering the drawer
    addCartDrawerListeners();
  }

  // cart icon listener
  document.querySelector('.cart-button').addEventListener('click', e => {
    openCartDrawer();
  });

  // send info to GA
  async function sendResponseToGA(response) {
    const responseData = await response.json();

    let params = {
      objectID: responseData.id
    };

    const urlParams = new URLSearchParams(window.location.search);
    const queryID = urlParams.get('queryID');

    // check if url has a queryID from PLP
    if (queryID) {
      params.queryID = queryID;
    }

    // send event to segment
    window.trackProductAdd(params);
  }

  // product forms listener
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();

      const ctaBtn = form.querySelector('button#add-to-cart');

      if (!ctaBtn) return;

      try {
        updateCtaLoadingState(ctaBtn);

        const response = await fetch('/cart/add.js', {
          method: 'post',
          body: new FormData(form)
        });

        if (!response.ok) {
          throw new Error('Error adding item to cart:', response.statusText);
        }

        await sendResponseToGA(response);

        await reloadCartData();
      } catch (error) {
        console.error('Error:', error);
      }
    });
  });

  // bundle products listener
  document.querySelectorAll('form[action="/cart/add/bundle"]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const data = {
        items: []
      };
      const bundleProductId = form.getAttribute('data-productid');
      const selectedOptions = document.querySelectorAll(
        '.bundle-product-variant-id'
      );
      const bundleQuantity =
        Number(document.getElementById('bundle-product-quantity').value) || 1;
      const bundleDiscount = Number(
        document.getElementById('bundle-product-discount').value
      );

      selectedOptions.forEach(option => {
        const variantId = Number(option.value);
        const lineItem = {
          id: variantId,
          quantity: 1 * bundleQuantity,
          properties: {
            _bundle_product_id: bundleProductId
          }
        };
        if (bundleDiscount) {
          lineItem.properties['_bundle_product_discount'] = bundleDiscount;
        }
        // reverse the items order to match cart products order with pdp products order
        data.items.unshift(lineItem);
      });
      const ctaBtn = form.querySelector('button#add-to-cart');

      if (!ctaBtn) return;
      updateCtaLoadingState(ctaBtn);
      try {
        const response = await fetch('/cart/add.js', {
          method: 'post',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        await reloadCartData();
      } catch (error) {
        console.error('Error:', error);
      }
    });
  });

  async function reloadCartData() {
    // get the cart count
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    // update the cart count
    await updateCartItemCounts(cart.item_count);

    // refresh cart
    await replaceCartContents();

    // open cart drawer
    openCartDrawer();
  }

  /**
   *
   * @returns {integer} scrollPosition
   */
  function getScrollPosition() {
    // save cart-inner scroll position
    const quickCartItems = document.querySelector('.quick-cart__inner');
    if (!quickCartItems) return;
    const scrollPosition = quickCartItems.scrollTop;
    return scrollPosition;
  }

  // function trackKlaviyoAddedToCart(cart) {
  //   let _learnq = window._learnq || [];
  //   let cartObj = {
  //     total_price: cart.total_price / 100,
  //     $value: cart.total_price / 100,
  //     total_discount: cart.total_discount,
  //     original_total_price: cart.original_total_price / 100,
  //     items: cart.items
  //   };
  //   if (item !== 'undefined') {
  //     cartObj = Object.assign(cartObj, item);
  //   }
  //   if (klAjax) {
  //     _learnq.push(['track', 'Added to Cart', cartObj]);
  //     console.log('event sent with cart', cartObj);
  //     klAjax = false;
  //   }
  // }
  // })(window, window.fetch);
  // let klAjax = true;
  // const atcButtons = document.querySelectorAll(
  //   '.add-to-cart, #add-to-cart, #modal-submit-btn'
  // );
  // for (let i = 0; i < atcButtons.length; i++) {
  //   atcButtons[i].addEventListener('click', function () {
  //     if (klAjax) {
  //       _learnq.push(['track', 'Added to Cart', item]);
  //       klAjax = false;
  //       console.log('event sent with item', item);
  //     }
  //   });
  // }

  function addCartDrawerListeners() {
    // close drawer
    document
      .querySelectorAll('#quick-cart-close, .quick-cart__overlay')
      .forEach(el => {
        el.addEventListener('click', () => {
          closeCartDrawer();
        });
      });
    document
      .querySelector('.quick-cart__inner')
      .addEventListener('click', e => {
        e.stopPropagation();
      });

    // Update quantities
    document
      .querySelectorAll('.quick-cart .quantity button')
      .forEach(button => {
        button.addEventListener('click', async e => {
          e.preventDefault();
          // Get line item key
          const cartItem = button.closest('.quick-cart-item');
          const key = cartItem.getAttribute('data-line-item-key');
          // Check for bundle item
          const bundleId = cartItem.getAttribute('data-bundle-id');
          // Get new quantity
          const quantitySelector = button.parentElement.querySelector('input');
          const currentQuantity = Number(quantitySelector.value);
          const isUp = button.classList.contains(
            'quick-cart-quantity-selector-plus'
          );
          const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

          const updates = { [key]: newQuantity };

          if (bundleId) {
            document
              .querySelectorAll(
                `.quick-cart-item[data-bundle-id="${bundleId}"]`
              )
              .forEach(bundleItem => {
                const bundleKey = bundleItem.getAttribute('data-line-item-key');
                updates[bundleKey] = newQuantity;
              });
          }
          const response = await fetch('/cart/update.js', {
            method: 'post',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
          });
          const cart = await response.json();

          await updateCartItemCounts(cart.item_count);
          await replaceCartContents(getScrollPosition());
        });
        // remove button
        document.querySelectorAll('.remove-item').forEach(remove => {
          remove.addEventListener('click', async e => {
            e.preventDefault();

            remove.innerHTML = spinnerWidget;
            const item = remove.closest('.quick-cart-item');
            const key = item.getAttribute('data-line-item-key');
            // Check for bundle item
            const bundleId = item.getAttribute('data-bundle-id');

            if (bundleId) {
              const updates = {};
              document
                .querySelectorAll(
                  `.quick-cart-item[data-bundle-id="${bundleId}"]`
                )
                .forEach(bundleItem => {
                  const bundleKey =
                    bundleItem.getAttribute('data-line-item-key');
                  updates[bundleKey] = 0;
                });

              const response = await fetch('/cart/update.js', {
                method: 'post',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const data = await response.json();
              await updateCartItemCounts(data.item_count);
              // save cart-inner scroll position
              await replaceCartContents(getScrollPosition());
            } else {
              const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: key, quantity: 0 })
              });
              const data = await response.json();
              await updateCartItemCounts(data.item_count);
              await replaceCartContents(getScrollPosition());
            }
          });
        });
      });
    // Gift message
    const giftMessage = document.getElementById('gift-message');
    const giftMessageToggle = document.getElementById('gift-message-toggle');

    if (giftMessage) {
      giftMessage.value = '';
      giftMessageToggle.addEventListener('change', function () {
        toggleMessage(this.checked);
      });
      giftMessageToggle.value = this.checked;

      // Event listener to prevent emojis in the textarea
      giftMessage.addEventListener('input', function () {
        const textValue = this.value;
        if (hasEmojis(textValue)) {
          // Remove emojis from the textarea value
          const newText = textValue.replace(emojiRegex, '');
          this.value = newText.trim();
        }
      });
      function toggleMessage(checked) {
        if (checked) {
          giftMessage.style.display = 'block';
        } else {
          giftMessage.style.display = 'none';
        }
      }

      const emojiRegex =
        /(?![\d])[\p{Emoji}\p{Emoji_Modifier}\p{Emoji_Component}\p{Emoji_Modifier_Base}\p{Emoji_Presentation}]/gu;
      // Function to check if the entered text contains emojis
      function hasEmojis(text) {
        return emojiRegex.test(text);
      }
    }
  }

  return {
    addItemToCart,
    replaceCartContents
  };
})(BOLD.jQuery || jQuery);
